export default {
    // bgColor: '#110f10',
  
    primary: {
      light: '',
      main: '',
      dark: '',
    },
  
    secondary: {
      light: '',
      main: '',
      dark: '',
    },
  
    auxiliar: {
      info: '',
      success: '',
      warning: '',
      danger: '',
    },
  
    text: {
      dark: {
        little: '#666',
        medium: '#333',
        very: '#111',
      },
      light: {
        little: '#aaa',
        medium: '#ccc',
        very: '#fff',
      },
    },
  };
  